import type { RefObject } from 'react';
import { PanelLinkAction } from './PanelLinkAction';

interface Props {
    headingRef: RefObject<HTMLHeadingElement | null>;
    onBack?: () => void;
}

export function CreateInvoiceHeader({ headingRef, onBack }: Props) {
    return (
        <div className="flex flex-col gap-2">
            {onBack && (
                <PanelLinkAction onClick={onBack}>Back to previously invoiced</PanelLinkAction>
            )}
            <h3
                ref={headingRef}
                tabIndex={-1}
                className="text-sm font-semibold text-mp-foreground focus-visible:outline-hidden focus-visible:ring-3 focus-visible:ring-mp-primary"
            >
                Create invoice
            </h3>
        </div>
    );
}
